import { DialogueUIConfig, DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario5 from "./Scenario5";

export default class Scenario5Part4 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 0;
	chapterIds = {
		scenario5_4B_s17: 'CALM - Scenario 5 - 4B - Segment 17',
		scenario5_1C_s18: 'CALM - Scenario 5 - 1C - Segment 18',
		scenario5_4C_s19: 'CALM - Scenario 5 - 4C - Segment 19',
		scenario5_4C_s20: 'CALM - Scenario 5 - 4C - Segment 20',
	}

	constructor(scenario: Scenario5, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario5/calm-scenario5-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario5.parts.level5Part7.id;
	}

	public start() {
		const context = this;
		context.segment1Step1MarcoApproaches();

	}

	private segment1Step1MarcoApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		
			context.segment1Step2Dialogue();
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C10-S1-020b',
			[{
				text: 'No, go ahead and discharge him.',
				feedback: 'For demonstration purposes first review any discharge orders by referring to the Unit Discharge Checklist.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank Zero
			}, {
				text: 'Review the discharge orders, referring to the Unit Discharge Checklist if available.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best_s
			}],
			(selectedOption: DialogueUIOptionConfig, config: DialogueUIConfig) => {
				context.scenario.evaluateAnswer_s(selectedOption, () => {
					context.segment2Step1MarcoResponds();
				}, () => {
					context.segment2Step1MarcoResponds();
					}
				)
				context.scenario.evaluateAnswerForSummative(selectedOption, {
					onOptionSelected: () => { },
					options: [
						{
							text: 'No, go ahead and discharge him.',
							scoreType: ScoreType.Zero,
							isCorrect: false // Rank Zero
						}, {
							text: 'Review the discharge orders, referring to the Unit Discharge Checklist if available.',
							scoreType: ScoreType.Best,
							isCorrect: true // Rank best_s
						}
					],
					aarScenarioID: 2,
					aarSectionID: 1,
					aarCollectionID: [config.selectedAnswer]
				}, () => { }, context.partIndx)
			}
		);
		context.scenario.updateObjective('Select your response to Marco');
	}

	private segment2Step1MarcoResponds() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario5_4B_s17, () => {
			context.segment3Step1NSCDischargeChecklist();
		});
		context.scenario.updateObjective('Look up the Unit Discharge Checklist with Marco');
	}

	private segment3Step1NSCDischargeChecklist() { // This interaction is just a scrollable text field with text		
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: null,
			review: { 
				text:
					`
			<p class="regular-description-font" style="margin: 0">
				<span style="color: rgb(222, 225, 156)">Unit Discharge Checklist</span> <br /><br />
				1. Make and print appointment(s). Include follow-up appointment for patients on Coumadin (warfarin).<br /><br />

				2. Email Inventory Manager to process rental equipment (bed or wound vac) for removal.<br /><br />
				
				3. Notify clothing room for patient’s belongings. Open till 4:30pm M-F. <br /><br />
				
				4. Review vital signs to ensure patient is stable for discharge.<br /><br />
				
				5. Collect MRSA culture and place in lab box.
				
				6. Review the latest Multi-D discharge planning note for needs that should be addressed before discharge.<br /><br />
				
				7. Review/document Flu vaccine.<br /><br />
				
				8. Review/document Pneumovac or Prevnar 13.<br /><br />
				
				9. Remove all invasive lines/tubes (Hep Lock) before discharge, when indicated.<br /><br />
				
				10. Remove telemetry monitor from patient, if applicable.<br /><br />
				
				11. Educate patient/family on medications such as warfarin, equipment, self-care, etc.<br /><br />
				
				12. Advise patient to pick up meds at pharmacy using ID bracelet/card.<br /><br />
				
				13. Ensure additional supplies/equipment are sent home with patient (wound care, enteral nutrition, prostheses equipment, etc.).<br /><br />
				
				14. Ensure patient belongings are packed and patient leaves with all money/personal items and clothing sheet signed by discharge RN.<br /><br />
				
				15. Arrange patient travel, if needed.<br /><br />
				
				16. Call report to receiving facility, if applicable.<br /><br />
				
				17. Complete nursing discharge note in CPRS.<br /><br />
				
				18. Address Interdisciplinary Plan of Care note.
			</p>
			`
			},
			reflects: null,
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId);
				context.onDone();
			}
		})
	}	
}